import { useMutation, useQueryClient } from "react-query";
import addAttributesHandler from "./handlers/addAttributesHandler";
import addAttributesResponder from "./responders/addAttributesResponder";
import addToAttributesStore from "../../../helpers/Attribute/addAttributesToStore";

const useCreateAttributes = () => {
  const queryClient = useQueryClient();
  const createMutation = useMutation(
    addAttributesHandler,
    addAttributesResponder(queryClient)
  );

  /**
   * Create Attribute
   *
   * @param {Props} createdItems: Array of Attributes to add
   * @param {boolean} newRequest optional defaults to true, if false is sent an api request will not be attempted
   */
  const createAttributes = async (props, newRequest = true) => {
    if (!props?.args?.createdItems) {
      return console.error(
        "createAttributes | props.args.createdItems is required"
      );
    }

    if (newRequest === false) {
      return addToAttributesStore({
        queryClient,
        attributes: props.args.createdItems,
      });
    }
    const response = await createMutation.mutateAsync(props);
    return response;
  };

  const {
    isLoading: isLoadingAttributes,
    isError: hasCreateAttributesError,
    error: createAttributesError,
    isSuccess: createAttributesSuccess,
  } = createMutation;

  return {
    createAttributes,
    isLoadingAttributes,
    hasCreateAttributesError,
    createAttributesError,
    createAttributesSuccess,
  };
};

export default useCreateAttributes;
